import ActionCable from 'actioncable'


// Multiple raygun errors were visible because argument 0 was undefined and this broke the proper functioning of this library.
// The raygun error is called: Cannot read properties of undefined (reading 'received')
ActionCable.Subscriptions.prototype.notifyOld = ActionCable.Subscriptions.prototype.notify
ActionCable.Subscriptions.prototype.notify = function() {
  if (!arguments[0]) return []
  return this.notifyOld(...arguments)
};

const CableWrapper = function (apiClient) {
  this.cable = null
  this.api = apiClient
}

/**
 * Return a promise Containing the cable consumer, instanciate it if necessary
 * @returns {Promise}
 */
CableWrapper.prototype.getCable = function () {
  const self = this
  if (!self.cable) {
    return self.api.get('/websocket/token').then(response => {
      self.cable = ActionCable.createConsumer(`${process.env.BASE_WEBSOCKET}/cable?token=${response.token}`)
      return self.cable
    })
  }
  return Promise.resolve(self.cable)
}
/**
 * Return a Promise containing cable subscriptions
 */
CableWrapper.prototype.getSubscriptions = function () {
  return this.getCable().then(cable => cable.subscriptions)
}

CableWrapper.prototype.disconnect = function () {
  if (this.cable) {
    this.cable.disconnect()
    this.cable = null
  }
}

export default CableWrapper
